import { useQuery } from '@tanstack/react-query';
import { validateInvite } from '@/api/invites.api';

/**
 * Validates an invite token on landing (US-038 AC1/AC3). Doesn't retry - an
 * invalid/expired/accepted token is a terminal state, not a transient error.
 */
export function useInvite(token: string) {
  return useQuery({
    queryKey: ['invite', token],
    queryFn: () => validateInvite(token),
    retry: false,
  });
}
